import { ReactNode } from 'react'
import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import clsx from 'clsx'
import classes from './SolutionHIL.module.scss'

interface TitleProps {
  text: string
  optional?: boolean
  h64?: boolean
}

interface HowItLooksGridProps {
  titles: TitleProps[]
  children: ReactNode[]
  fiveItems?: boolean
}

export const SolutionHIL = ({
  titles,
  children,
  fiveItems = false,
}: HowItLooksGridProps) => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'content'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.heading}>
        <Heading as={'h2'} size={'xl'} center className={classes.title}>
          How it looks for your customers
        </Heading>
        <Text size={'lg'} center className={classes.subtitle}>
          This UX is fully controlled by you and can be customized in many ways.
        </Text>
      </div>

      <ul className={clsx(classes.list, fiveItems && classes.list__five)}>
        {titles.map((title, index) => (
          <li key={index} className={classes.item}>
            <Text
              as={'span'}
              center
              className={classes.itemNumber}
            >{`0${index + 1}`}</Text>
            <Heading
              as={'h3'}
              size={'sm'}
              center
              className={clsx(
                classes.itemTitle,
                title.h64 && classes.itemTitle__h64,
              )}
            >
              {title.text}
              {title.optional && (
                <Text as={'span'} size={'sm'} className={classes.itemText}>
                  Optional
                </Text>
              )}
            </Heading>
            {children[index]}
          </li>
        ))}
      </ul>
    </Block>
  )
}
